import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Money } from './Money'

/** Under a total that counts every campaign's spend: how much of it belongs
 *  to campaigns tied to no app, so the total and the per-app figures below
 *  it (mapped spend only) can be told apart. Nothing when there is none or
 *  spend is not shown. Links to 캠페인, where a campaign is tied to an app. */
export function UnmappedSpend({ amount, shown = true, className }: { amount: number | null | undefined; shown?: boolean; className?: string }) {
  // unmapped_cost is a difference of two float sums: under half a cent is noise.
  if (!shown || !amount || amount < 0.005) return null
  return (
    <p className={cn('text-meta text-muted-foreground', className)}>
      앱에 연결 안 된 캠페인 지출 <Money value={amount} className="text-foreground" /> 포함 ·{' '}
      <Link to="/campaigns" className="font-medium text-accent hover:underline">
        캠페인
      </Link>
    </p>
  )
}
